export default __webpack_public_path__ + "static/media/kitchen3-afterD-1024w.930dd569.png";